export type TLocationProperty = {
	latitude: number;
	longitude: number;
	dataSource?: string;
	heading?: number;
	epoch?: number;
} | undefined;

export const convertToLocationProperty = (data: {[key: string]: string}, _epoch?: string): TLocationProperty => {
	const latitude = data["lat"] ?? data["REPORT:location:latitude"];
	const longitude = data["lng"] ?? data["REPORT:location:longitude"];
	const dataSource = data["REPORT:location:dataSource"];
	const epoch = _epoch || data["REPORT:location:latitude:clock"];

	if (!latitude || !longitude || !epoch) {
		return undefined;
	}

	return {
		latitude: Number.parseFloat(latitude),
		longitude: Number.parseFloat(longitude),
		dataSource,
		epoch: Number.parseInt(epoch, 10),
	};
};
